import * as customFieldTypes from 'constants/customFieldTypes'
import * as fieldMenuButtonTypes from 'constants/fieldMenuButtonTypes'

export default (fieldType) => {
  switch (fieldType) {
    case customFieldTypes.PRODUCT:
      return [
        fieldMenuButtonTypes.OPEN,
        fieldMenuButtonTypes.DESIGN,
        fieldMenuButtonTypes.PRODUCTS
      ]
    case customFieldTypes.BULLET_POINTS:
      return [
        fieldMenuButtonTypes.DESIGN,
        {
          ...fieldMenuButtonTypes.EDIT_TEXT,
          isBullets: true
        }
      ]
    case customFieldTypes.TEXT:
      return [
        fieldMenuButtonTypes.DESIGN,
        fieldMenuButtonTypes.EDIT_TEXT
      ]
    case customFieldTypes.VIDEO:
    case customFieldTypes.IMAGE:
      return [
        fieldMenuButtonTypes.DESIGN,
        fieldMenuButtonTypes.ASSETS,
      ]
    case customFieldTypes.SHOPIFY_VARIANTS:
    case customFieldTypes.BG:
      return [
        fieldMenuButtonTypes.DESIGN
      ]
    case customFieldTypes.INSTA_LAYOUT:
      return [
        fieldMenuButtonTypes.EDIT_LAYOUT
      ]
    case customFieldTypes.ACTION_BUTTON_W_EMAIL:
      return [
        fieldMenuButtonTypes.EDIT_TEXT,
        fieldMenuButtonTypes.EDIT_EMAIL
      ]
    case customFieldTypes.ACTION_BUTTON:
      return [
        fieldMenuButtonTypes.OPEN,
        fieldMenuButtonTypes.EDIT_TEXT
      ]
    case customFieldTypes.ACTION_BUTTON_W_DESIGN:
      return [
        fieldMenuButtonTypes.OPEN,
        fieldMenuButtonTypes.DESIGN,
        fieldMenuButtonTypes.EDIT_TEXT
      ]
    case customFieldTypes.ACTION_BUTTON_W_URL:
      return [
        fieldMenuButtonTypes.EDIT_TEXT,
        fieldMenuButtonTypes.EDIT_URL
      ]
    case customFieldTypes.SHARE_BUTTON:
      return [
        fieldMenuButtonTypes.OPEN
      ]
    case customFieldTypes.EDIT_SOCIAL_URL:
      return [
        fieldMenuButtonTypes.EDIT_SOCIAL
      ]
    case customFieldTypes.CUSTOM_BUTTON_W_URL:
      return [
        fieldMenuButtonTypes.DESIGN,
        fieldMenuButtonTypes.EDIT_TEXT,
        fieldMenuButtonTypes.EDIT_URL
      ]
    case customFieldTypes.BUTTONS_CONTAINER:
      return [
        fieldMenuButtonTypes.DESIGN
      ]
    case customFieldTypes.OPTIONAL_BLOCK:
      return [
        fieldMenuButtonTypes.CHOOSE_TYPE
      ]
    default:
      return []
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/fieldMenu/fieldButtonTypes.js